import React, { useContext, useEffect, useState } from "react";
import "./CookieConsent.css";
import { ThemeContext } from "ThemeContext";
import { useSelector } from "react-redux";
import langData from "lang/data";
const CookieConsent = () => {
    const { setShowModal, setConsent } = useContext(ThemeContext);
    const [show, setShow] = useState(false);
    const setCookie = (name, value, days = 365) => {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    };
    const { currentLanguage } = useSelector(({ main }) => main);
    const getCookie = (name) => {
        const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
        return match ? match[2] : null;
    };
    useEffect(() => {
        const consent = getCookie("cookieConsent");
        if (!consent) setShow(true);
    }, []);

    const handleAccept = () => {
        setCookie("cookieConsent", "accepted");
        setConsent("accepted");
        setShow(false);
        setShowModal(true);
    };
    const handleDecline = () => {
        setCookie("cookieConsent", "declined", 30);
        setConsent("declined");
        setShow(false);
        setShowModal(true);
    };


    if (!show) return null;

    return (
        <div class="cookie-overlay">
            <div className="cookie-modal">
                <img class="cookie-img" src="https://vlv.am/public/cookie.svg" alt="cookie" />

                <div className="cookie-text">
                    <h2>{langData.CookieModalTitle?.[currentLanguage]}</h2>
                    <p>{langData.CookieModalText?.[currentLanguage]}</p>
                </div>

                <div className="actions">
                    <button onClick={handleAccept} className="btn accept">{langData.CookieModalAccept?.[currentLanguage]}</button>
                    <button onClick={handleDecline} className="btn decline">{langData.CookieModalDecline?.[currentLanguage]}</button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;


